module.exports = __webpack_public_path__ + "img/ready-to-scan-1_transparent.e6b7baee.png";